import script from "./PageAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./PageAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./PageAnalytics.vue?vue&type=style&index=0&id=4ebe087f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebe087f"]])

export default __exports__